
        module.exports = __webpack_public_path__ + "assets/images/fod-nl-2023.72ec0382.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 271,
            height: 61,
            type: "svg",
            bytes: 27521,

            toString: function() {
                return src;
            }
        };
    